import { getEnv } from "../../config/getEnv";

/**
 * Error handling middleware for Redux
 * - Logs errors when debug mode is enabled
 * - Preserves errors so callers can handle them appropriately
 * - Does NOT swallow errors gracefully
 */
const errorMiddleware = (store) => (next) => (action) => {
  // Check if this is an error action (RTK Query or custom)
  if (action.error) {
    // Log error if debug logging is enabled
    if (getEnv("REACT_APP_ENABLE_REDUX_LOGGER") === "true") {
      console.error("[Redux Error Action]", {
        type: action.type,
        error: action.error,
        payload: action.payload,
        timestamp: new Date().toISOString(),
      });
    }

    // Pass the error through - callers should handle it
    // This ensures components can display appropriate error messages
  }

  // Continue with the action
  return next(action);
};

export default errorMiddleware;
